enum GameModes {
    SCENARIO = "SCENARIO",
    MATCH_PLAY = "MATCH_PLAY",
    OVERALL = "OVERALL"
};

export default GameModes;